import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
    HttpClientInMemoryWebApiModule,
    InMemoryBackendConfigArgs
} from 'angular-in-memory-web-api';
import { PortalFrontendMockBackend } from './portal-frontend-mock-backend';

@NgModule({
    declarations: [],
    imports: [
        CommonModule,
        HttpClientInMemoryWebApiModule.forRoot(PortalFrontendMockBackend, {
            apiBase: 'supplier-api/',
            passThruUnknownUrl: true
        } as InMemoryBackendConfigArgs)
    ],
})
export class PortalMockBackendModule { }
